import { render, staticRenderFns } from "./RegisterMissing.vue?vue&type=template&id=b5dc22f2&"
import script from "./RegisterMissing.vue?vue&type=script&lang=js&"
export * from "./RegisterMissing.vue?vue&type=script&lang=js&"
import style0 from "./RegisterMissing.vue?vue&type=style&index=0&id=b5dc22f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports